"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["className", "makeId", "model", "valueChanged"],
  _excluded2 = ["className", "makeId", "model"];
var _FleetModelSelect_HomepageQuery, _InputLoading;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { InputLoading } from '@autoguru/components';
import { VehicleModelSelect } from '@autoguru/components/components/VehicleModelSelect/VehicleModelSelect';
import { graphql } from 'react-relay';
import { useLazyLoadQuery } from 'react-relay/hooks';
import { AsyncBoundary } from '@autoguru/suspense';
import { jsx as _jsx } from "react/jsx-runtime";
const FleetModelSelectInput = _ref => {
  let {
      className = '',
      makeId,
      model,
      valueChanged
    } = _ref,
    inputProps = _objectWithoutProperties(_ref, _excluded);
  const {
    node
  } = useLazyLoadQuery(_FleetModelSelect_HomepageQuery !== void 0 ? _FleetModelSelect_HomepageQuery : _FleetModelSelect_HomepageQuery = require("../../../../../packages/relay/__generated__/FleetModelSelect_HomepageQuery.graphql"), {
    id: makeId
  });
  return /*#__PURE__*/_jsx(VehicleModelSelect, _objectSpread(_objectSpread({
    className: className
  }, inputProps), {}, {
    models: node.models,
    model: model,
    onChange: valueChanged
  }));
};
export const FleetModelSelect = _ref2 => {
  let {
      className = '',
      makeId,
      model
    } = _ref2,
    inputProps = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(AsyncBoundary, {
    fallback: _InputLoading || (_InputLoading = /*#__PURE__*/_jsx(InputLoading, {})),
    children: makeId ? /*#__PURE__*/_jsx(FleetModelSelectInput, _objectSpread(_objectSpread({}, inputProps), {}, {
      makeId: makeId,
      className: className,
      model: model
    })) : /*#__PURE__*/_jsx(VehicleModelSelect, _objectSpread(_objectSpread({
      className: className,
      waitingMessage: "No results. Please select a make, to view the models of that vehicle."
    }, inputProps), {}, {
      models: [],
      model: model
    }))
  });
};